import React from 'react';

const AnnotationActionsContext = React.createContext();

export default AnnotationActionsContext;
